import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap, tap } from "rxjs/operators";
import { of } from "rxjs";
import { ApiResponse } from "../../models/common.model";
import { clearBizShopBanner, loadBizShopBanner, loadBizShopBannerFailure, loadBizShopBannerSuccess } from "./biz-shop-banner.action";
import { CustomerService } from "../../services/customer.service";

@Injectable()
export class BizShopBannerEffects {
  constructor(private actions$: Actions, private customerService: CustomerService) {}

  // Effect to load filtered Banner
  loadBizShopBanner$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadBizShopBanner),
      tap(() => {
        return clearBizShopBanner();
      }),
      switchMap((action: { adminId?: any }) =>
        this.customerService.getBizShopBanner(action.adminId).pipe(
          map((response: ApiResponse) => {
            return loadBizShopBannerSuccess({ bizShopBanner: response.body });
          }),
          catchError((error) =>
            of(
              loadBizShopBannerFailure({
                error: {
                  message: error.message || "An unknown error occurred",
                  statusCode: error.status || 500,
                },
              })
            )
          )
        )
      )
    )
  );
}
